(ns nl.mediquest.questionnaire-frontend.util
  (:require
   [clojure.string :as string]
   [nl.mediquest.questionnaire-frontend.config :as config]
   [nl.mediquest.questionnaire-frontend.events :as events]
   [re-frame.core :as re-frame]))

(defn navigate-to-questionnaire
  [{:keys [questionnaire-deployment-id] :as _state}]
  (let [questionnaire-id (re-frame/subscribe [:questionnaire/questionnaire-id])]
    (when config/debug?
      (prn ::navigate-to-questionnaire questionnaire-id))
    (when questionnaire-deployment-id
      (re-frame/dispatch [::events/internal-redirect
                          (->> (string/trim questionnaire-deployment-id)
                               (str "/" @questionnaire-id "/"))]))))

(defn nothing-filled-in? [state]
  (empty? (:questionnaire-deployment-id @state)))

(defn- handle-input-event-fn [state k]
  (fn [event]
    (let [text (-> event .-target .-value)]
      (swap! state assoc k text))))

(defn labeled-input-field [state k text auto-focus?]
  [:input {:id k
           :placeholder text
           :auto-focus auto-focus?
           :value (k @state)
           :on-change (handle-input-event-fn state k)
           :type "text"
           :auto-capitalize "off"}])

(defn get-current-year []
  (.getFullYear (js/Date.)))

(def ^:private locale->js-locale
  {:nl "nl-NL" :en "en-GB" :de "de-DE" :fr "fr-FR"})

(defn format-date
  "Format ISO date string based on locale, e.g., '9 februari 2026'."
  ([iso-string]
   (format-date iso-string :nl))
  ([iso-string locale]
   (when iso-string
     (.toLocaleDateString
      (js/Date. iso-string)
      (locale->js-locale locale "nl-NL")
      #js {:day "numeric" :month "long" :year "numeric"}))))

(defn- dutch-month-short [date]
  (-> (.toLocaleDateString date "nl-NL" #js {:month "short"})
      (string/replace "." "")))

(defn pdf-filename
  "Constructs PDF filename with date and meetmoment suffix.
  `base-name` is the filename without extension.
  `iso-date-string` is an ISO date string (e.g. '2026-02-24').
  `meetmoment` is the meetmoment number (integer)."
  [base-name iso-date-string meetmoment]
  (let [date (js/Date. iso-date-string)
        month-short (dutch-month-short date)
        year-short (mod (.getFullYear date) 100)]
    (str base-name
         "_" month-short year-short
         "_meetmoment" (or meetmoment 1) ".pdf")))
